import React, { useState, useEffect } from "react";
import "./OfflineIndicator.css";

/**
 * Shows a banner at the top of the screen when the user goes offline,
 * and a brief "Back online" confirmation when connectivity is restored.
 */
function OfflineIndicator() {
  const [status, setStatus] = useState("online"); // "online" | "offline" | "restored"

  useEffect(() => {
    const goOffline = () => setStatus("offline");
    const goOnline  = () => {
      setStatus("restored");
      const t = setTimeout(() => setStatus("online"), 3000);
      return () => clearTimeout(t);
    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online",  goOnline);
    // Initialise
    if (!navigator.onLine) setStatus("offline");

    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online",  goOnline);
    };
  }, []);

  if (status === "online") return null;

  return (
    <div className={`offline-indicator offline-indicator--${status}`} role="status">
      {status === "offline" && (
        <>
          <span className="offline-indicator__icon">📶</span>
          <span>You're offline — some features may be unavailable</span>
        </>
      )}
      {status === "restored" && (
        <>
          <span className="offline-indicator__icon">✅</span>
          <span>Back online</span>
        </>
      )}
    </div>
  );
}

export default OfflineIndicator;
